export default __webpack_public_path__ + "static/media/BLACKROCK.18b22dab.jpeg";